// ** MUI Imports
import { styled, useTheme } from '@mui/material/styles'
import MuiAppBar from '@mui/material/AppBar'
import MuiToolbar from '@mui/material/Toolbar'

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  transition: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 6),
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  minHeight: theme.mixins.toolbar.minHeight,
  maxHeight: theme.mixins.toolbar.minHeight,
  height: theme.mixins.toolbar.minHeight,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}))

const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  width: '100%',
  padding: '0 !important',
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  minHeight: `${theme.mixins.toolbar.minHeight}px !important`,
  maxHeight: `${theme.mixins.toolbar.minHeight}px !important`,
  height: `${theme.mixins.toolbar.minHeight}px !important`
}))

const LayoutAppBar = props => {
  // ** Props
  const { settings, appBarProps, appBarContent: userAppBarContent } = props

  // ** Hooks
  const theme = useTheme()

  // ** Vars
  const { appBar, contentWidth } = settings

  if (appBar === 'hidden') {
    return null
  }
  let userAppBarStyle = {}

  if (appBarProps && appBarProps.sx) {
    userAppBarStyle = appBarProps.sx
  }
  const userAppBarProps = Object.assign({}, appBarProps)

  delete userAppBarProps.sx

  return (
    
    <AppBar
      elevation={0}
      color='default'
      className='layout-navbar'
      sx={{
        background: `linear-gradient(120deg, #ffffff 0%, #ffffff calc(100% - 180px), transparent calc(100% - 399px)) no-repeat,
                      linear-gradient(120deg, #ECF0F1 0%, #ECF0F1 calc(100% - 10px), transparent calc(100% - 174px)) no-repeat,
                    #1B205C`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'right top',
        '@media (max-width: 1200px)': {
          background: `linear-gradient(120deg, #ffffff 0%, #ffffff calc(100% - 400px), transparent calc(100% - 399px)) no-repeat,
                        linear-gradient(120deg, #ECF0F1 0%, #ECF0F1 calc(100% - 150px), transparent calc(100% - 149px)) no-repeat,
                      #1B205C`
        },
        '@media (max-width: 768px)': {
          background: `
      linear-gradient(120deg, #b4b8d5 0%, #ffffff calc(100% - 240px), transparent calc(100% - 240px)) no-repeat,
      linear-gradient(120deg, #ECF0F1 0%, #ECF0F1 calc(100% - 129px), transparent calc(100% - 129px)) no-repeat,
      #1B205C
    `
          // background: `linear-gradient(120deg, #ffffff 0%, #ffffff calc(100% - 0240px), transparent calc(100% - 240px)) no-repeat,
          //               linear-gradient(120deg, #ECF0F1 0%, #ECF0F1 calc(100% - 130px), transparent calc(100% - 130px)) no-repeat,
          //             #1B205C`
        },
        ...userAppBarStyle
      }}
      position='static'
      {...userAppBarProps}
    >
      <Toolbar
        className='navbar-content-container'
        sx={{
          ...(contentWidth === 'boxed' && {
            '@media (min-width:1440px)': { maxWidth: `calc(1440px - ${theme.spacing(6)} * 2)` }
          })
        }}
      >
        {(userAppBarContent && userAppBarContent(props)) || null}
      </Toolbar>
    </AppBar>
  )
}

export default LayoutAppBar
